import React from "react";

import { faArrowUpRightFromSquare } from "@fortawesome/pro-solid-svg-icons/faArrowUpRightFromSquare";
import { defineMessages, useIntl } from "react-intl";

import ToolButton from "@app/component/map/FeaturedMap/essentials/controls/ToolButton";

const messages = defineMessages({
  openOnMap: {
    id: "dashboard.cards.noContactIn.map.openOnMap",
    defaultMessage: "Open on Main map",
    description: "Open on map button in No Contact In card on the Dashboard page",
  },
});

interface Props {
  onClick?: () => void;
}

const OpenOnMap: React.FC<Props> = ({ onClick }) => {
  const intl = useIntl();
  return (
    <ToolButton
      icon={faArrowUpRightFromSquare}
      onClick={onClick}
      title={intl.formatMessage(messages.openOnMap)}
    />
  );
};

export default OpenOnMap;
